// import React, { useState } from "react";
// import { TextField, Button, Stack } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { addHours } from "date-fns";
// import { useTranslation } from "react-i18next";
// import Cookies from "js-cookie";

// const DateForm = ({
//   onSubmit,
// }: {
//   onSubmit: (startAt: string, stopAt: string, description: string, error: boolean) => void;
// }) => {
//     // I18N
//     const { t } = useTranslation();
//     const savedLang = Cookies.get('language');
//     const [startAt, setStartAt] = useState<Date | null>(new Date());
//     const [stopAt, setStopAt] = useState<Date | null>(addHours(new Date(), 1));
//     const [description, setDescription] = useState<string>("");

//     const handleSubmit = () => {
//         if (!startAt || !stopAt) {
//             // alert("Les deux dates sont obligatoires");
//             onSubmit(startAt.toISOString(), stopAt.toISOString(), description, true);
//         return;
//         }

//         onSubmit(startAt.toISOString(), stopAt.toISOString(), description, false);
//     };

//     return (
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <Stack spacing={2} sx={{ maxWidth: 400, margin: "auto", mt: 4 }}>
//             <DateTimePicker
//             label={t('request.start')}
//             value={startAt}
//             onChange={(newValue) => setStartAt(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//             />

//             <DateTimePicker
//             label={t('request.stop')}
//             value={stopAt}
//             onChange={(newValue) => setStopAt(newValue)}
//             renderInput={(params) => <TextField {...params} />}
//             />

//             <TextField
//                 label="Description"
//                 value={description}
//                 onChange={(event) => setDescription(event.target.value)}
//             />

//             <Button variant="contained" onClick={handleSubmit}>
//                 {t('request.createLeave')}
//             </Button>
//             {/* <Button 
//                 type="submit" 
//                 onClick={handleSubmit(leaveRequest)} 
//                 disabled={!startAt || !stopAt || loadingUsers}
//                 >
//                 {loadingUsers ? t('signup.loading') : t('request.submitRequest')}
//             </Button> */}
//         </Stack>
//         </LocalizationProvider>
//     );
// };

// export default DateForm;

import React from "react";
import { useForm, Controller } from "react-hook-form";
import { TextField, Button, Stack } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { addHours } from "date-fns";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

type FormValues = {
  startAt: Date | null;
  stopAt: Date | null;
  description: string;
};

const DateForm = ({
  onSubmit,
}: {
  onSubmit: (startAt: string, stopAt: string, description: string, error: boolean) => void;
}) => {
  const { t } = useTranslation();
  const savedLang = Cookies.get("language");

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      startAt: new Date(),
      stopAt: addHours(new Date(), 1),
      description: "",
    },
  });

  const onFormSubmit = (data: FormValues) => {
    if (!data.startAt || !data.stopAt) {
      onSubmit("", "", data.description, true);
    } else {
      onSubmit(data.startAt.toISOString(), data.stopAt.toISOString(), data.description, false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <form onSubmit={handleSubmit(onFormSubmit)} style={{margin: '0 auto'}}>
        <Stack spacing={2} sx={{ maxWidth: 400, margin: "auto", mt: 4 }}>
          <Controller
            name="startAt"
            control={control}
            render={({ field }) => (
              <DateTimePicker
                label={t("request.start")}
                value={field.value}
                onChange={field.onChange}
                renderInput={(params) => <TextField {...params} />}
              />
            )}
          />

          <Controller
            name="stopAt"
            control={control}
            render={({ field }) => (
              <DateTimePicker
                label={t("request.stop")}
                value={field.value}
                onChange={field.onChange}
                renderInput={(params) => <TextField {...params} />}
              />
            )}
          />

          <TextField
            label="Description"
            {...register("description", { required: true })}
            error={!!errors.description}
            helperText={errors.description ? t("form.required") : ""}
          />

          <Button type="submit" variant="contained">
            {t("request.createLeave")}
          </Button>
        </Stack>
      </form>
    </LocalizationProvider>
  );
};

export default DateForm;
